var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddExpenseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0859 7.7191V1",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2719 4.37824L10.8467 4.31738",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12572 1.88184H4.44712C3.59505 1.88184 2.77792 2.23584 2.17541 2.86588C1.57291 3.49592 1.23438 4.35038 1.23438 5.2414V13.6403C1.23438 14.5313 1.57291 15.3858 2.17541 16.0158C2.77792 16.6459 3.59505 16.9999 4.44712 16.9999H14.0854C14.9375 16.9999 15.7546 16.6459 16.3571 16.0158C16.9597 15.3858 17.2981 14.5313 17.2981 13.6403V10.2219",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23438 7H3.94116C4.58022 7 5.19306 7.26543 5.64494 7.73795C6.09682 8.21048 6.35072 8.8514 6.35072 9.5197C6.35072 10.1879 6.09682 10.8288 5.64494 11.3014C5.19306 11.7739 4.58022 12.0394 3.94116 12.0394H1.23438",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddExpenseIcon);
export default __webpack_public_path__ + "static/media/addExpenseIcon.bc7decffd26446a63b4421f6679695a0.svg";
export { ForwardRef as ReactComponent };